import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { MenuItem, Menu } from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';

import Theme from '../ui/Theme';
import { getJourneyDetails, getLevelDetails, showProgress } from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { ErrorToast, notifySuccess, formatDurationSeconds } from '../utils/Utils';
import AddDeleteConfirmation from '../common/AddDeleteConfirmation';
import { apiEndpoints } from '../../constants/apiEndpoints';
import Image from '../common/Image';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  menuRoot: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',

    display: 'flex',
    alignItems: 'center',
    textAlign: 'right',

    color: 'black',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function JourneyCard({ values, change, level, handleOpenGuide }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);
  const val = values;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [viewConfirmDeleteGuide, setViewConfirmDeleteGuide] = React.useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickMenu = async (e) => {
    const selectedMenu = e.target.innerText;
    if (selectedMenu === 'Change Order') {
      setAnchorEl(null);
      change();
    } else if (selectedMenu === 'Change Level') {
      setAnchorEl(null);
      level();
    }
  };
  const handleDeleteGuide = async () => {
    dispatch(showProgress(true));
    await Service.delete(apiEndpoints.JOURNEY_GUIDE_BY_ID.replace('GUIDE_ID', val.id))
      .then(async () => {
        notifySuccess('Deleted Successfully');
        dispatch(getLevelDetails('guideDetailsdelete', val.id));
        // Fetch updated journey details from API
        if (journeyDetails?.id) {
          const journeyResponse = await Service.get(apiEndpoints.JOURNEY_BY_ID.replace('ID', journeyDetails.id), '');
          dispatch(getJourneyDetails('updateJourneyDetails', journeyResponse));
        }
        dispatch(showProgress(false));
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const handleOpenDeleteConfirmation = () => {
    setAnchorEl(null);
    setViewConfirmDeleteGuide(true);
  };
  const handleCloseDeleteConfirmation = () => {
    setViewConfirmDeleteGuide(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Card
      as="section"
      className={classes.root}
      variant="outlined"
      style={{
        borderColor: Theme.palette.secondary.main,
        backgroundColor: Theme.palette.secondary.main,
        cursor: 'pointer',
      }}
    >
      <CardContent style={{ padding: '10px 7px' }}>
        <Grid container justifyContent="flex-start" alignItems="center">
          <Grid
            item
            style={{
              width: '20%',
              marginLeft: '15px',
            }}
            onClick={handleOpenGuide}
          >
            {values.thumbnail ? (
              <Image src={values.thumbnail} alt="img" style={{ height: '87px', width: '95px' }} />
            ) : (
              <Skeleton animation={false} variant="rectangular" width="95px" height="87px" />
            )}
          </Grid>
          <Grid item onClick={handleOpenGuide} style={{ height: '87px', width: '71%' }}>
            <Typography
              variant="h6"
              component="h6"
              style={{
                textAlign: 'left',
                fontSize: '14px',
                fontWeight: 600,
                lineHeight: '17px',
                fontStyle: 'normal',
                marginTop: '20px',
              }}
            >
              {values.title}
            </Typography>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              style={{
                fontFamily: 'Montserrat',
                fontStyle: 'normal',
                fontWeight: '600',
                fontSize: '12px',
                lineHeight: '15px',
                marginTop: '6px',
                color: '#6663FF',
              }}
            >
              {values.type === 'guide' ? 'Guide' : 'AI Roleplay Exercise'}
            </Typography>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              style={{
                fontFamily: 'Montserrat',
                fontStyle: 'normal',
                fontWeight: '600',
                fontSize: '12px',
                lineHeight: '15px',
                marginTop: '6px',
                color: '#6663FF',
              }}
            >
              {formatDurationSeconds(values?.duration)}
            </Typography>
          </Grid>
          <Grid item style={{ width: '4%' }}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item>
                <MoreVert aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          style={{ justifyContent: 'left' }}
          value="Change Level"
          className={classes.menuRoot}
          onClick={handleClickMenu}
        >
          Change Level
        </MenuItem>
        {values?.type === 'guide' && (
          <MenuItem
            style={{ justifyContent: 'left' }}
            value="Copy Guide Scheme Deeplink"
            className={classes.menuRoot}
            onClick={() => {
              navigator.clipboard.writeText(values.schemeDeeplink);
              notifySuccess('Guide Scheme Deeplink Copied');
            }}
          >
            Copy Scheme Deeplink
          </MenuItem>
        )}

        {values?.type === 'guide' && (
          <MenuItem
            style={{ justifyContent: 'left' }}
            value="Copy Guide Universal Deeplink"
            className={classes.menuRoot}
            onClick={() => {
              navigator.clipboard.writeText(values.universalDeeplink);
              notifySuccess('Guide Universal Deeplink Copied');
            }}
          >
            Copy Universal Deeplink
          </MenuItem>
        )}
        <MenuItem
          style={{ justifyContent: 'left' }}
          value="Change Order"
          className={classes.menuRoot}
          onClick={handleClickMenu}
        >
          Change Order
        </MenuItem>
        {values?.type === 'guide' && (
          <MenuItem
            style={{ justifyContent: 'left' }}
            value="Delete Guide"
            className={classes.menuRoot}
            onClick={handleOpenDeleteConfirmation}
          >
            Delete Guide
          </MenuItem>
        )}
      </Menu>
      {viewConfirmDeleteGuide && (
        <AddDeleteConfirmation open close={handleCloseDeleteConfirmation} delFn={handleDeleteGuide} title="Guide" />
      )}
    </Card>
  );
}
